import { gql } from 'apollo-angular';
import { commentDetailFragment } from '../comment/comment.fragments';
import { workspaceUserItemFragment } from '../user/user.fragments';

export const logItemFragment = gql`
  fragment LogItemFragment on CardLog {
    id
    actor {
      ...WorkspaceUserItem
    }
    logChanges
    logType

    card {
      ... on GoalCard {
        id
        linkedCards {
          ... on GoalCard {
            id
          }

          ... on EventCard {
            id
          }
        }
      }

      ... on EventCard {
        id
        linkedCards {
          ... on GoalCard {
            id
          }

          ... on EventCard {
            id
          }
        }
      }
    }

    subject {
      ... on GoalCard {
        id
        createdAt
        severity
        title
        endDate
        startDate
        creator {
          ...WorkspaceUserItem
        }
        goalCardStatus
        subDomain {
          id
          title
        }
      }
      ... on EventCard {
        id
        createdAt
        title
        endDate
        startDate
        creator {
          ...WorkspaceUserItem
        }
        eventCardStatus
      }
      ... on CardTask {
        id
        createdAt
        title
        cardTaskStatus
        creator {
          ...WorkspaceUserItem
        }
      }

      ...CommentDetailFragment

      ... on User {
        id
      }
    }
    subjectUser {
      ...WorkspaceUserItem
    }
    updatedAt
    createdAt
  }
  ${workspaceUserItemFragment}
  ${commentDetailFragment}
`;
